import { Paginated } from "./types";

/**
 * A `setQueryData` / `setQueriesData` updater for paginated caches: rewrites
 * every page's rows and leaves an unpopulated cache untouched. `mapRows` gets
 * the page's index, for updates that belong on one page (appending a row).
 */
const mapPaginatedRows =
  <T>(mapRows: (rows: T[], pageIndex: number) => T[]) =>
  (old?: Paginated<T>) =>
    old && {
      ...old,
      pages: old.pages.map((page, index) => ({
        ...page,
        data: mapRows(page.data ?? [], index),
      })),
    };

export default mapPaginatedRows;
